import { Breadcrumb, Card, message, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePost } from "../../../../hooks/usePost";
import { usePostTypes } from "../../../../hooks/usePostType";
import { useTags } from "../../../../hooks/useTag";
import { AddEditPostForm } from "../components/AddEditPostForm";

const { Title } = Typography;

export function PostDetail() {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const { data, create, update } = usePost(id);

  const { data: postTypes } = usePostTypes({ page: 1, limit: 100 });
  const { data: tags } = useTags({ page: 1, limit: 100 });

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        type: data.type?._id || data.type,
        tags: data.tags?.map((tag) => tag._id || tag) || [],
        image: data.imageUrl
          ? [
              {
                uid: "-1",
                name: "image",
                status: "done",
                url: data.imageUrl,
              },
            ]
          : [],
      });
    }
  }, [data, form]);

  const handleSubmit = async (values) => {
    try {
      if (id && id !== "create") {
        await update.mutateAsync({ id, body: values });
        form.resetFields();
        message.success("Cập nhật dữ liệu thành công");
        return;
      }

      const res = await create.mutateAsync(values);
      navigate(`/bang-dieu-khien/tin-tuc/${res._id}`);
      message.success("Tạo dữ liệu thành công");
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 24, padding: 24 }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[
              { title: "Bảng điều khiển" },
              { title: "Tin tức", href: "/bang-dieu-khien/tin-tuc" },
              {
                title:
                  id && id !== "create" ? "Chi tiết tin tức" : "Tạo tin tức",
              },
            ]}
          />
          <Title level={3} style={{ margin: 0 }}>
            {id && id !== "create" ? "Chi tiết tin tức" : "Tạo tin tức"}
          </Title>
        </div>
      </div>

      <Card>
        <AddEditPostForm
          form={form}
          loading={create.isPending || update.isPending}
          onSubmit={handleSubmit}
          postTypes={postTypes}
          tags={tags}
        />
      </Card>
    </div>
  );
}
